<template>
  <div id="Home_recommend">
    <div class="recommend_list">
      <template v-for="item in dataList">
        <router-link :to="productUrl(item)">
          <div class="item" data-item-theme :style="$hueToStyle(item.hue_hex)" @click="trackClickItem(item.id)">
            <div class="img">
              <img class="IconPic" width="60" height="60"  v-lazy="item.icon_img" :alt="item.name">
            </div>
            <div class="T">
              <div class="name">{{item.name}}</div>
              <div class="price"><b>{{item.price_format}}</b></div>
            </div>
          </div>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import Oppo from "@/api/oppo";
import GTMTrack from "@/api/gtm-track";

export default {
  name: "HomeRecommend",
  computed:{
    merchantCode(){
      return process.env.VUE_APP_MERCHANT_CODE
    }
  },
  props:{
    dataList:[]
  },
  activated() {
  },
  methods:{
    trackClickItem(id) {
      for (let i = 0; i < this.dataList.length; i++) {
        if (this.dataList[i].id == id) {
          GTMTrack.clickCategory(this.dataList[i].name)
          break
        }
      }
    },
    productUrl(category) {
      if (category.mode === 'pin') {
        return '/card/' + category.code
      }
      if (category.mode === 'directtopup') {
        return '/direct-top-up/' + category.code
      }
      return '/'
    }
  }
}
</script>

<style scoped>

</style>
